import OpenInfo from "./open-info";
export default OpenInfo;
